import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useDispatch, useSelector } from 'react-redux'
import Header from './components/Header/Header'
import FilteringModal from './components/FilteringModal/FilteringModal'
import { enqueueNotification } from '../../../redux/slices/notificationsSlice'
import { useReportsAccountingAPAgingMutation } from '../../../services'
import { getCurrentDate } from '../../../utils/general'
import { UspReportAccountsPayableAgingResult } from '../../../models'
import AccountsPayableAgingTableBlock from './components/AccountsPayableAgingTableBlock/AccountsPayableAgingTableBlock'
import { useNavigate } from 'react-router-dom'
import { getUserAccessRights } from '../../../redux/slices/authSlice'
import { appRoute } from '../../../constants'
import { Card, Container } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'

const AccountsPayableAging = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userAccess = useSelector(getUserAccessRights)
  const [showTable, setShowTable] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(true)
  const [formValues, setFormValues] = useState<any>(null)

  const [filterAPAging, { data: filterData, isSuccess: filterIsSuccess, isLoading: filterIsLoading }] = useReportsAccountingAPAgingMutation()

  const handleOpenFilterModal = () => setOpenFilterModal(true)
  const handleCloseFilterModal = () => setOpenFilterModal(false)

  const handleSubmit = (values: any) => {
    const jsonBranchList = values?.Branch?.map((item: any) => ({ BranchID: item?.BranchID }))
    const jsonVendorList = values?.Vendor?.map((item: any) => ({ VendorID: item?.ID }))

    filterAPAging({
      uspReportAccountsPayableAging: {
        asOfDate: getCurrentDate(),
        apChartOfAccountID: values?.COA || null,
        jsonBranchList: jsonBranchList || null,
        jsonVendorList: jsonVendorList || null,
      },
    })
    setFormValues(values)
  }

  useEffect(() => {
    if (filterIsSuccess) {
      handleCloseFilterModal()
      setShowTable(true)
      dispatch(enqueueNotification({ message: 'Success' }))
    }
  }, [filterIsSuccess])

  useEffect(() => {
    if (!userAccess.CanAccessAccountingInsights) {
      dispatch(
        enqueueNotification({
          message:
            'Access Denied: Sorry, your current access rights do not permit you to enter this section. If you believe you should have access, please contact your system administrator or help desk for assistance.',
          options: { variant: 'error' },
        }),
      )
      navigate(appRoute.Home)
    }
  }, [userAccess, appRoute])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Reports'
        links={[
          {
            href: appRoute.Insights,
            name: 'List',
          },
          {
            name: 'Accounts Payable Aging',
          },
        ]}
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Card
        sx={{
          flexGrow: { md: 1 },
          display: { md: 'flex' },
          flexDirection: { md: 'column' },
        }}
      >
        <Form keepDirtyOnReinitialize onSubmit={handleSubmit}>
          {({ handleSubmit }: any) => (
            <form onSubmit={handleSubmit}>
              {showTable && <Header handleOpenFilterModal={handleOpenFilterModal} filterData={filterData as UspReportAccountsPayableAgingResult[]} />}
              <FilteringModal formValues={formValues} open={openFilterModal} handleClose={handleCloseFilterModal} />
              {showTable && (
                <AccountsPayableAgingTableBlock filterData={filterData as UspReportAccountsPayableAgingResult[]} isLoading={filterIsLoading} />
              )}
            </form>
          )}
        </Form>
      </Card>
    </Container>
  )
}
export default AccountsPayableAging
